// source (2018-03-11): https://github.com/jquery/jquery/blob/master/src/css/hiddenVisibleSelectors.js
export function isElementVisible(element: HTMLElement) {
  return (
    !!element && !!(element.offsetWidth || element.offsetHeight || element.getClientRects().length)
  );
}
